import { useSyncExternalStore } from 'react'

const emptySubscribe = () => () => {}

/**
 * SSR 与水合首帧返回 false，水合完成后返回 true；纯客户端渲染（createRoot）下始终为 true。
 * 用于让「视口/浏览器环境相关」的渲染分支在水合阶段与服务端保持一致，避免 hydration 告警。
 */
export function useHydrated() {
  return useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false
  )
}
